<template>
    <div>
        <!-- Mobile Header -->
        <div class="wsmobileheader clearfix">
            <a id="wsnavtoggle" class="wsanimated-arrow"><span></span></a>
            <span class="smllogo"><img v-bind:src="`${baseUrl}assets/image/esomobay.png`" width="120" alt="ই-সমবায়"/></span>
            <a href="tel:01710636667" class="callusbtn"><i class="fas fa-phone"></i></a>
        </div>
        <!-- Mobile Header -->

        <div class="headerfull">
            <div class="wsmain clearfix">
                <div class="smllogo">
                    <router-link to="/"><img v-bind:src="`${baseUrl}assets/image/esomobay.png`" width="145" alt="E-SOMOBAY"/></router-link>
                </div>
                <nav class="wsmenu clearfix">
                    <ul class="wsmenu-list">

                        <li class="border-right">
                            <router-link to="/" class="navtext closenav" exact><span>ড্যাশবোর্ড</span></router-link>
                        </li>

                        <li v-if="accessTypes.includes('2') || accessRole == 1" aria-haspopup="true" class="border-right">
                            <a href="javascript:void(0);" class="navtext"><span class="submenu-icon">সদস্য</span></a>
                            <ul class="sub-menu">
                                <li v-if="accessModules.includes('4') || accessRole == 1" class="border-bottom"><router-link to="/member/create" class="closenav">সদস্য ভর্তি</router-link></li>
                                <li v-if="accessModules.includes('5') || accessRole == 1"><router-link to="/member/lists" class="closenav">সদস্য তালিকা</router-link></li>
                            </ul>
                        </li>

                        <li v-if="accessTypes.includes('3') || accessRole == 1" aria-haspopup="true" class="border-right">
                            <a href="javascript:void(0);" class="navtext"><span class="submenu-icon">লেনদেন</span></a>
                            <div class="wsmegamenu clearfix halfmenu">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="wstliststy06 clearfix">
                                                <li class="wstheading clearfix">শেয়ার</li>
                                                <li v-if="accessModules.includes('8') || accessRole == 1"><router-link to="/share/collection" class="closenav">শেয়ার গ্রহণ</router-link></li>
                                                <li v-if="accessModules.includes('9') || accessRole == 1"><router-link to="/share/withdraw" class="closenav">শেয়ার উত্তোলন</router-link></li>

                                                <li class="wstheading clearfix">মেয়াদী আমানত</li>
                                                <li v-if="accessModules.includes('17') || accessRole == 1"><router-link to="/fdr/collection" class="closenav">মেয়াদী আমানত গ্রহণ</router-link></li>
                                                <li v-if="accessModules.includes('18') || accessRole == 1"><router-link to="/fdr/withdraw" class="closenav">মেয়াদী আমানত উত্তোলন</router-link></li>

                                                <li class="wstheading clearfix">সঞ্চয় আমানত</li>
                                                <li v-if="accessModules.includes('21') || accessRole == 1"><router-link to="/saving/collection" class="closenav">সঞ্চয় আমানত গ্রহণ</router-link></li>
                                                <li v-if="accessModules.includes('22') || accessRole == 1"><router-link to="/saving/withdraw" class="closenav">সঞ্চয় আমানত উত্তোলন</router-link></li>
                                            </ul>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="wstliststy06 clearfix">
                                                <li class="wstheading clearfix">ঋণ / বিনিয়োগ</li>
                                                <li v-if="accessModules.includes('12') || accessRole == 1"><router-link to="/loan/create" class="closenav">ঋণ প্রদান</router-link></li>
                                                <li v-if="accessModules.includes('13') || accessRole == 1"><router-link to="/installment/create" class="closenav">ঋণের কিস্তি আদায়</router-link></li>

                                                <li class="wstheading clearfix">হাওলাত</li>
                                                <li v-if="accessModules.includes('25') || accessRole == 1"><router-link to="/borrow/collection" class="closenav">হাওলাত গ্রহণ</router-link></li>
                                                <li v-if="accessModules.includes('26') || accessRole == 1"><router-link to="/borrow/withdraw" class="closenav">হাওলাত ফেরত</router-link></li>

                                                <li class="wstheading clearfix">অন্যান্য</li>
                                                <li v-if="accessModules.includes('29') || accessRole == 1"><router-link to="/salary/create" class="closenav">বেতন-ভাতাদি প্রদান</router-link></li>
                                                <li v-if="accessModules.includes('31') || accessRole == 1"><router-link to="/particular-transaction/create" class="closenav">অন্যান্য লেনদেন</router-link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li v-if="accessTypes.includes('4') || accessRole == 1" aria-haspopup="true" class="border-right">
                            <a href="javascript:void(0);" class="navtext"><span class="submenu-icon">লেনদেনের তালিকা</span></a>
                            <div class="wsmegamenu clearfix halfmenu">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="wstliststy06 clearfix">
                                                <li class="wstheading clearfix">শেয়ার</li>
                                                <li v-if="accessModules.includes('10') || accessRole == 1"><router-link to="/share/lists" class="closenav">শেয়ারের তালিকা</router-link></li>

                                                <li class="wstheading clearfix">মেয়াদী আমানত</li>
                                                <li v-if="accessModules.includes('19') || accessRole == 1"><router-link to="/fdr/lists" class="closenav">মেয়াদী আমানতের তালিকা</router-link></li>

                                                <li class="wstheading clearfix">সঞ্চয় আমানত</li>
                                                <li v-if="accessModules.includes('23') || accessRole == 1"><router-link to="/saving/lists" class="closenav">সঞ্চয় আমানতের তালিকা</router-link></li>
                                            </ul>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="wstliststy06 clearfix">
                                                <li class="wstheading clearfix">ঋণ / বিনিয়োগ</li>
                                                <li v-if="accessModules.includes('14') || accessRole == 1"><router-link to="/loan/lists" class="closenav">ঋণের তালিকা</router-link></li>
                                                <li v-if="accessModules.includes('84') || accessRole == 1"><router-link to="/installment/lists" class="closenav">কিস্তির তালিকা</router-link></li>

                                                <li class="wstheading clearfix">হাওলাত</li>
                                                <li v-if="accessModules.includes('27') || accessRole == 1"><router-link to="/borrow/lists" class="closenav">হাওলাতের তালিকা</router-link></li>

                                                <li class="wstheading clearfix">অন্যান্য</li>
                                                <li v-if="accessModules.includes('30') || accessRole == 1"><router-link to="/salary/lists" class="closenav">বেতন-ভাতাদির তালিকা</router-link></li>
                                                <li v-if="accessModules.includes('32') || accessRole == 1"><router-link to="/particular-transaction/lists" class="closenav">অন্যান্য লেনদেনের তালিকা</router-link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li v-if="accessTypes.includes('6') || accessTypes.includes('7') || accessRole == 1" aria-haspopup="true" class="border-right">
                            <a href="javascript:void(0);" class="navtext"><span class="submenu-icon">রিপোর্ট</span></a>
                            <div class="wsmegamenu clearfix halfmenu">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div v-if="accessTypes.includes('6') || accessRole == 1" class="col-lg-6 col-md-12">
                                            <ul class="wstliststy06 clearfix">
                                                <li class="wstheading clearfix">জমা খরচ রিপোর্ট</li>
                                                <li v-if="accessModules.includes('39') || accessRole == 1"><router-link to="/report/collection" class="closenav">মাসিক জমার হিসাব</router-link></li>
                                                <li v-if="accessModules.includes('40') || accessRole == 1"><router-link to="/report/expenditure" class="closenav">মাসিক খরচের হিসাব</router-link></li>
                                                <li v-if="accessModules.includes('41') || accessRole == 1"><router-link to="/report/collection-expenditure" class="closenav">জমা খরচ হিসাব</router-link></li>
                                                <li v-if="accessModules.includes('43') || accessRole == 1"><router-link to="/report/transaction" class="closenav">লেনদেনের রিপোর্ট</router-link></li>
                                                <li v-if="accessModules.includes('44') || accessRole == 1"><router-link to="/report/tasks" class="closenav">লেনদেনের কার্যতালিকা</router-link></li>
                                            </ul>
                                        </div>
                                        <div v-if="accessTypes.includes('7') || accessRole == 1" class="col-lg-6 col-md-12">
                                            <ul class="wstliststy06 clearfix">
                                                <li class="wstheading clearfix">হিসাব প্রতিবেদন</li>
                                                <li v-if="accessModules.includes('45') || accessRole == 1"><router-link to="/accounts/general-ledger" class="closenav">সাধারণ খতিয়ান</router-link></li>
                                                <li v-if="accessModules.includes('46') || accessRole == 1"><router-link to="/accounts/trial-balance" class="closenav">রেওয়ামিল</router-link></li>
                                                <li v-if="accessModules.includes('47') || accessRole == 1"><router-link to="/accounts/profit-loss" class="closenav">লাভ-ক্ষতি ও বন্টন হিসাব</router-link></li>
                                                <li v-if="accessModules.includes('48') || accessRole == 1"><router-link to="/accounts/balance-sheet" class="closenav">উদ্বৃত্তপত্র</router-link></li>
                                                <li v-if="accessModules.includes('49') || accessRole == 1"><router-link to="/accounts/detail-lists" class="closenav">ডিটেল লিস্ট</router-link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li v-if="accessTypes.includes('5') || accessRole == 1" aria-haspopup="true" class="border-right">
                            <a href="javascript:void(0);" class="navtext"><span class="submenu-icon">আদায় ফর্ম</span></a>
                            <ul class="sub-menu">
                                <li v-if="accessModules.includes('34') || accessRole == 1" class="border-bottom"><router-link to="/collection/installment" class="closenav">কিস্তি আদায় ফর্ম</router-link></li>
                                <li v-if="accessModules.includes('35') || accessRole == 1" class="border-bottom"><router-link to="/collection/expired-loan" class="closenav">মেয়াদউত্তীর্ণ ঋণের কিস্তি আদায় ফর্ম</router-link></li>
                                <li v-if="accessModules.includes('36') || accessRole == 1" class="border-bottom"><router-link to="/collection/saving" class="closenav">সঞ্চয় আদায় ফর্ম</router-link></li>
                                <li v-if="accessModules.includes('37') || accessRole == 1" class="border-bottom"><router-link to="/collection/general" class="closenav">সকল আদায় ফর্ম</router-link></li>
                                <li v-if="accessModules.includes('37') || accessRole == 1" class="border-bottom"><router-link to="/collection/monthly" class="closenav">মাসিক আদায় ফর্ম</router-link></li>
                                <li v-if="accessModules.includes('38') || accessRole == 1" class="border-bottom"><router-link to="/report/transaction-collection" class="closenav">সকল আদায়ের পরিমান</router-link></li>
                            </ul>
                        </li>

                        <li v-if="accessTypes.includes('8') || accessRole == 1" aria-haspopup="true" class="border-right">
                            <a href="javascript:void(0);" class="navtext"><span class="submenu-icon">এসএমএস</span></a>
                            <ul class="sub-menu">
                                <li v-if="accessModules.includes('50') || accessRole == 1" class="border-bottom"><router-link to="/sms/new" class="closenav">নতুন এসএমএস</router-link></li>
                                <li v-if="accessModules.includes('51') || accessRole == 1"><router-link to="/sms/lists" class="closenav">এসএমএস তালিকা</router-link></li>
                            </ul>
                        </li>

                        <li v-if="accessTypes.includes('9') || accessRole == 1" aria-haspopup="true" class="border-right">
                            <a href="javascript:void(0);" class="navtext"><span class="submenu-icon">অ্যাডমিন</span></a>
                            <ul class="sub-menu">
                                <li v-if="accessModules.includes('54') || accessRole == 1" class="border-bottom"><router-link to="/admin/lists" class="closenav">অ্যাডমিন তালিকা</router-link></li>
                                <li v-if="accessModules.includes('57') || accessRole == 1"><router-link to="/admin/permission" class="closenav">অ্যাডমিন কার্যক্ষমতা</router-link></li>
                            </ul>
                        </li>

                        <li v-if="accessTypes.includes('10') || accessRole == 1" aria-haspopup="true" class="border-right">
                            <a href="javascript:void(0);" class="navtext"><span class="submenu-icon">সেটিংস</span></a>
                            <div class="wsmegamenu clearfix halfmenu">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="wstliststy06 clearfix">
                                                <li class="wstheading clearfix">সাধারণ সেটিংস</li>
                                                <li v-if="accessModules.includes('68') || accessRole == 1"><router-link to="/group/lists" class="closenav">সদস্য গ্রুপের তালিকা</router-link></li>
                                                <li v-if="accessModules.includes('71') || accessRole == 1"><router-link to="/center/lists" class="closenav">সদস্য কেন্দ্রের তালিকা</router-link></li>
                                                <li v-if="accessModules.includes('60') || accessRole == 1"><router-link to="/audit/lists" class="closenav">অডিট/নিরীক্ষার তথ্যাদি</router-link></li>
                                                <li v-if="accessModules.includes('63') || accessRole == 1"><router-link to="/holidays/lists" class="closenav">ছুটির তালিকা</router-link></li>
                                                <li v-if="accessModules.includes('65') || accessRole == 1"><router-link to="/particular/lists" class="closenav">লেনদেনের খাতের তালিকা</router-link></li>
                                            </ul>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="wstliststy06 clearfix">
                                                <li class="wstheading clearfix">সফটওয়্যার সেটিংস</li>
                                                <li v-if="accessModules.includes('74') || accessRole == 1"><router-link to="/event/lists" class="closenav">সভা/বৈঠকের তালিকা</router-link></li>
                                                <li v-if="accessModules.includes('77') || accessRole == 1"><router-link to="/committee/lists" class="closenav">ব্যবস্থাপনা কমিটি</router-link></li>
                                                <li v-if="accessModules.includes('80') || accessRole == 1"><router-link to="/notice/lists" class="closenav">নোটিশ বোর্ড</router-link></li>
                                                <li v-if="accessModules.includes('81') || accessRole == 1"><router-link to="/settings/view" class="closenav">সফটওয়্যার সেটিংস</router-link></li>
                                                <li><a href="https://wa.me/+8801710636667" class="closenav" target="_blank">যোগাযোগ</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li aria-haspopup="true" class="wsshopmyaccount border-left border-right">
                            <span class="wsmenu-click"><i class="wsmenu-arrow"></i></span>
                            <a href="javascript:void(0);">
                                <!--<i class="fa fa-chevron-circle-down"></i>-->
                                <img class="menu-profile-img" v-bind:src="`${IMAGEURL+adminImage}`" alt="Profile">
                                <span v-if="configData">{{configData.adminName}}</span>
                                <span v-else>আমার একাউন্ট</span>
                            </a>
                            <ul class="sub-menu">
                                <li><router-link to="/admin/profile" class="closenav"><i class="fas fa-user-tie"></i>আমার প্রোফাইল</router-link></li>
                                <li><router-link to="/admin/tasks" class="closenav"><i class="fas fa-tasks"></i>কার্যতালিকা</router-link></li>
                                <li><router-link to="/admin/profile" class="closenav"><i class="fas fa-lock"></i>পাসওয়ার্ড পরিবর্তন</router-link></li>
                                <li><a href="javascript:void(0)" @click="logout()"><i class="fas fa-sign-out-alt"></i>Logout</a></li>
                            </ul>
                        </li>

                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {logoutFromApp, logoutFromBackend} from "../../services/auth";

    export default {
        name: 'Menu',
        components: {},
        data() {
            return {
                configData: JSON.parse(localStorage.getItem("users")),
                accessRole: JSON.parse(localStorage.getItem("users")).role,
                adminImage: JSON.parse(localStorage.getItem("users")).image,
                accessTypes: JSON.parse(localStorage.getItem("users")).accessTypesId,
                accessModules: JSON.parse(localStorage.getItem("users")).accessModulesId
            };
        },
        mounted() {
            let customJavaScript = document.createElement('script');
            customJavaScript.async = true;
            customJavaScript.setAttribute('src', this.baseUrl + 'assets/webslidermenu/js/webslidemenu.js');
            document.head.appendChild(customJavaScript);
        },
        methods: {
            logout() {

                overlayLoading(true);

                logoutFromBackend().then((response) => {
                  if (response.status) {
                    this.flashMessage.success({message: response.message});
                  } else {
                    this.flashMessage.error({message: response.message});
                  }
                }).catch((e) => {
                  this.flashMessage.error({message: e});
                });

                setTimeout(function () {
                  logoutFromApp();
                }, 1000);
            }
        }
    }
</script>
<style>
    .callusbtn {
        color: #a9a9a9;
        font-size: 18px;
        position: absolute;
        right: 5px;
        top: 0px;
        transition: all 0.4s ease-in-out 0s;
        z-index: 102;
        padding: 12px 14px;
    }
</style>
